import { ExportOutlined, UploadOutlined, PlusCircleOutlined } from '@ant-design/icons'
import { Button, Upload } from 'antd'
import styled from 'styled-components'
import type { UploadRequestOption } from 'rc-upload/lib/interface';
const Wrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 15px;
  flex-wrap: wrap;
justify-content: center;
  svg {
    position: relative;
    top: 1px;
  }
`

type TActionGroup = {
  onAdd: () => void,
  onExport: () => void,
  onImport: (options: UploadRequestOption<any>) => void,
}

const ActionGroup = ({ onAdd, onExport, onImport }: TActionGroup) => {
  return (
    <Wrapper>
      <Button onClick={onAdd}>
        <PlusCircleOutlined /> Thêm mới
      </Button>
      <Button onClick={onExport}>
        <ExportOutlined /> Xuất file
      </Button>
      <Upload customRequest={onImport} showUploadList={false} accept=".xlsx">
        <Button>
          <UploadOutlined /> Nhập file
        </Button>
      </Upload>
    </Wrapper>
  )
}

export default ActionGroup
